import { DOWNLOADFILE, GET } from "../../API/get";

export const fetchJobInvoicesContent = async (job_id, invoice_type) => {
    const response = await GET(`job/invoices/content/${job_id}/${invoice_type}`);
    return response.status === "Success" ? response : null;
}

export const downloadInvoice = async (job_id, invoice_type) => {
    await DOWNLOADFILE(`job/invoices/download/${job_id}/${invoice_type}`);
}